export default "__VITE_ASSET__DCL83g0G__"